// src/lib/loading.js — HTML de loading reutilizável.

export function loadingHTML(label = 'Carregando…') {
  return `<div class="app-loading">${label}</div>`;
}

export function emptyState(message, icon = '📭') {
  return `<div class="empty-state" style="text-align:center;padding:60px 20px;color:var(--text3)">
    <div style="font-size:48px;margin-bottom:12px">${icon}</div>
    <div style="font-size:14px">${message}</div>
  </div>`;
}
